export const translations = {
  en: {
    // Navigation
    nav: {
      shop: 'Shop',
      about: 'About',
      contact: 'Contact',
      cart: 'Cart',
    },
    // Homepage
    home: {
      heroSubtitle: 'Himalayan Heritage',
      heroTitle: 'Timeless Elegance,',
      heroTitleItalic: 'Woven by Hand',
      heroDescription: 'Discover our collection of premium cashmere and wool garments, crafted by artisans using centuries-old Himalayan techniques.',
      shopCollection: 'Shop Collection',
      ourStory: 'Our Story',
      curatedSelection: 'Curated Selection',
      featuredCollection: 'Featured Collection',
      viewAllProducts: 'View All Products',
      explore: 'Explore',
      shopByCategory: 'Shop by Category',
      ourHeritage: 'Our Heritage',
      artOfCraftsmanship: 'The Art of Himalayan Craftsmanship',
      heritageQuote: '"Every thread tells a story of tradition, passed down through generations of master artisans."',
      heritageDescription: 'At Shiva Shakti, we honor the sacred balance between ancient wisdom and modern elegance. Our garments are crafted using techniques that have been perfected over centuries in the high Himalayan villages.',
      readOurStory: 'Read Our Story',
    },
    // Benefits
    benefits: {
      freeShipping: 'Free Worldwide Shipping',
      freeShippingDesc: 'On orders above €150',
      freeReturns: 'Free Returns',
      freeReturnsDesc: '30-day hassle-free returns',
      premiumQuality: 'Premium Quality',
      premiumQualityDesc: '100% authentic cashmere',
    },
    // Shop
    shop: {
      allCollections: 'All Collections',
      shopAll: 'Shop All',
      exploreCollection: 'Explore our complete collection of premium cashmere and wool garments.',
      filters: 'Filters',
      all: 'All',
      sortBy: 'Sort by:',
      featured: 'Featured',
      priceLowHigh: 'Price: Low to High',
      priceHighLow: 'Price: High to Low',
      nameAZ: 'Name: A-Z',
      showing: 'Showing',
      products: 'products',
      product: 'product',
      noProducts: 'No products found in this category.',
      clear: 'Clear',
    },
    // Product
    product: {
      backToShop: 'Back to Shop',
      color: 'Color',
      size: 'Size',
      addToCart: 'Add to Cart',
      fabricDetails: 'Fabric Details',
      careInstructions: 'Care Instructions',
      youMayAlsoLike: 'You May Also Like',
      productNotFound: 'Product Not Found',
    },
    // Cart
    cart: {
      title: 'Shopping Cart',
      empty: 'Your Cart is Empty',
      emptyDesc: 'Discover our collection of premium cashmere and wool garments.',
      continueShopping: 'Continue Shopping',
      orderSummary: 'Order Summary',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      free: 'Free',
      addMore: 'Add €{amount} more for free shipping',
      total: 'Total',
      includingTaxes: 'Including taxes',
      proceedToCheckout: 'Proceed to Checkout',
      secureCheckout: 'Secure checkout powered by Stripe',
      qty: 'Qty',
    },
    // Checkout
    checkout: {
      title: 'Checkout',
      contactInfo: 'Contact Information',
      email: 'Email',
      phone: 'Phone (optional)',
      shippingAddress: 'Shipping Address',
      firstName: 'First Name',
      lastName: 'Last Name',
      address: 'Address',
      city: 'City',
      postalCode: 'Postal Code',
      country: 'Country',
      qualifyFreeShipping: 'You qualify for free worldwide shipping!',
      paymentSecured: 'Your payment is secured by Stripe',
      payNow: 'Pay Now',
      processing: 'Processing...',
    },
    // Checkout Success
    success: {
      processing: 'Processing Your Order',
      pleaseWait: 'Please wait while we confirm your payment...',
      thankYou: 'Thank You for Your Order!',
      paymentSuccess: 'Your payment was successful. We\'ve sent a confirmation email with your order details.',
      whatsNext: 'What\'s Next?',
      preparing: 'We\'re preparing your order for shipment',
      trackingInfo: 'You\'ll receive tracking information via email',
      estimatedDelivery: 'Estimated delivery: 5-10 business days worldwide',
      amountPaid: 'Amount Paid',
      sessionExpired: 'Session Expired',
      sessionExpiredDesc: 'Your payment session has expired. Please try again.',
      somethingWrong: 'Something Went Wrong',
      somethingWrongDesc: 'We couldn\'t process your payment. Please try again or contact support.',
      returnToCart: 'Return to Cart',
      contactSupport: 'Contact Support',
    },
    // About
    about: {
      ourStory: 'Our Story',
      spiritOf: 'The Spirit of',
      ourPhilosophy: 'Our Philosophy',
      whereHeritageMeets: 'Where Heritage Meets Elegance',
      philosophyP1: 'Shiva Shakti represents the sacred balance of opposing forces—strength and grace, tradition and innovation, earth and spirit. Our brand embodies this philosophy in every thread.',
      philosophyQuote: '"We believe that true luxury lies not in excess, but in the purity of materials, the skill of human hands, and the stories woven into each garment."',
      philosophyP2: 'Founded with a vision to bring Himalayan craftsmanship to the modern world, we partner with artisan communities who have perfected their craft over centuries. Each piece carries the warmth of human touch and the wisdom of ancient traditions.',
      whatWeStandFor: 'What We Stand For',
      ourValues: 'Our Values',
      authenticCraftsmanship: 'Authentic Craftsmanship',
      authenticCraftsmanshipDesc: 'Every piece is handcrafted by skilled artisans using techniques passed down through generations. We preserve the ancient art of Himalayan weaving.',
      premiumMaterials: 'Premium Materials',
      premiumMaterialsDesc: 'We source only the finest Grade A cashmere and virgin wool from high-altitude Himalayan regions, ensuring exceptional softness and durability.',
      sustainablePractices: 'Sustainable Practices',
      sustainablePracticesDesc: 'Our commitment to sustainability means ethical sourcing, fair wages for artisans, and environmentally conscious production methods.',
      timelessDesign: 'Timeless Design',
      timelessDesignDesc: 'We create pieces that transcend trends—elegant, versatile garments designed to be treasured for years to come.',
      theProcess: 'The Process',
      fromMountainToWardrobe: 'From Mountain to Wardrobe',
      processP1: 'Our cashmere comes from Changthangi goats that roam freely in the high Himalayan plateaus, where extreme temperatures produce the world\'s finest, softest fibers.',
      processP2: 'Each spring, the fibers are gently combed by hand—never sheared—ensuring the comfort of the animals and the quality of the material. The raw cashmere is then cleaned, spun, and woven by master craftsmen using traditional looms.',
      processP3: 'The result is a garment of exceptional quality—lightweight yet incredibly warm, soft against the skin, and built to last for generations.',
      weaverBlessing: '"In every thread, we weave a prayer. In every stitch, we honor our ancestors. This is not just clothing—it is a legacy of love."',
      himalayanBlessing: '— Himalayan Weaver\'s Blessing',
    },
    // Contact
    contact: {
      getInTouch: 'Get in Touch',
      title: 'Contact Us',
      description: 'We\'d love to hear from you. Whether you have a question about our products, shipping, or anything else—our team is here to help.',
      sendMessage: 'Send Us a Message',
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      subjectPlaceholder: 'e.g., Order inquiry, Product question',
      message: 'Message',
      messagePlaceholder: 'How can we help you?',
      send: 'Send Message',
      sending: 'Sending...',
      contactInfo: 'Contact Information',
      phone: 'Phone',
      hours: 'Hours',
      hoursValue: 'Mon-Fri: 9am - 6pm CET',
      shippingPolicy: 'Shipping Policy',
      shippingP1: 'Free worldwide shipping on orders above €150',
      shippingP2: 'Standard shipping rates vary by region',
      shippingP3: 'Express shipping available at checkout',
      shippingP4: 'All orders include tracking information',
      returnsPolicy: 'Returns & Refunds',
      returnsP1: 'Free returns within 30 days of delivery',
      returnsP2: 'Items must be unworn with original tags',
      returnsP3: 'Full refund to original payment method',
      returnsP4: 'Contact us to initiate a return',
      messageSent: 'Message sent successfully!',
      messageDesc: 'We\'ll get back to you within 24 hours.',
    },
    // Footer
    footer: {
      tagline: '"Where Himalayan heritage meets contemporary elegance."',
      shop: 'Shop',
      support: 'Support',
      aboutUs: 'About Us',
      shippingPolicy: 'Shipping Policy',
      returnsRefunds: 'Returns & Refunds',
      securePayment: 'Secure Payment',
      sslEncryption: 'All transactions are secured with SSL encryption.',
      allRightsReserved: 'All rights reserved.',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
    },
    // Admin
    admin: {
      login: 'Admin Access',
      loginDesc: 'Please sign in to manage products',
      username: 'Username',
      password: 'Password',
      signIn: 'Sign In',
      signingIn: 'Signing in...',
      productManagement: 'Product Management',
      productManagementDesc: 'Add, edit, or remove products from your catalog',
      logout: 'Logout',
      addProduct: 'Add Product',
      noProducts: 'No products found',
      addFirstProduct: 'Add Your First Product',
      image: 'Image',
      name: 'Name',
      category: 'Category',
      price: 'Price',
      stock: 'Stock',
      inStock: 'In Stock',
      outOfStock: 'Out',
      featuredLabel: 'Featured',
      standard: 'Standard',
      actions: 'Actions',
      editProduct: 'Edit Product',
      addNewProduct: 'Add New Product',
      productName: 'Product Name',
      description: 'Description',
      productImages: 'Product Images',
      uploadFromDevice: 'Upload from device',
      addAnotherImage: 'Add Another Image',
      mapColorsToImages: 'Map Colors to Images',
      mapColorsDesc: 'Select which image should be shown when a customer selects each color.',
      selectImage: 'Select image for this color',
      noSpecificImage: 'No specific image',
      colors: 'Colors (comma-separated)',
      sizes: 'Sizes (comma-separated)',
      fabricDetails: 'Fabric Details',
      careInstructions: 'Care Instructions',
      featuredProduct: 'Featured Product',
      cancel: 'Cancel',
      updateProduct: 'Update Product',
      createProduct: 'Create Product',
      shippingConfig: 'Shipping Configuration',
      shippingConfigDesc: 'Configure shipping costs by region',
      freeShippingThreshold: 'Free Shipping Threshold (€)',
      germany: 'Germany',
      uk: 'United Kingdom',
      eu: 'EU (outside Germany)',
      us: 'United States',
      restOfWorld: 'Rest of World',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
    },
    // Language
    language: {
      en: 'English',
      de: 'Deutsch',
    },
    // Categories
    categories: {
      'cashmere-capes-ponchos': 'Cashmere Capes & Ponchos',
      'cashmere-pullovers': 'Pure Cashmere Pullovers',
      'cashmere-caps': 'Cashmere Caps',
      'tribal-ponchos': 'Woollen Tribal Ponchos',
      'tribal-shorts': 'Tribal / Yoga Pants',
    },
  },
  de: {
    // Navigation
    nav: {
      shop: 'Shop',
      about: 'Über uns',
      contact: 'Kontakt',
      cart: 'Warenkorb',
    },
    // Homepage
    home: {
      heroSubtitle: 'Himalaya-Erbe',
      heroTitle: 'Zeitlose Eleganz,',
      heroTitleItalic: 'Handgewebt',
      heroDescription: 'Entdecken Sie unsere Kollektion hochwertiger Kaschmir- und Wollkleidung, gefertigt von Kunsthandwerkern mit jahrhundertealten Himalaya-Techniken.',
      shopCollection: 'Kollektion ansehen',
      ourStory: 'Unsere Geschichte',
      curatedSelection: 'Kuratierte Auswahl',
      featuredCollection: 'Ausgewählte Kollektion',
      viewAllProducts: 'Alle Produkte ansehen',
      explore: 'Entdecken',
      shopByCategory: 'Nach Kategorie einkaufen',
      ourHeritage: 'Unser Erbe',
      artOfCraftsmanship: 'Die Kunst des Himalaya-Handwerks',
      heritageQuote: '"Jeder Faden erzählt eine Geschichte der Tradition, weitergegeben durch Generationen von Meisterhandwerkern."',
      heritageDescription: 'Bei Shiva Shakti ehren wir das heilige Gleichgewicht zwischen alter Weisheit und moderner Eleganz. Unsere Kleidungsstücke werden mit Techniken gefertigt, die über Jahrhunderte in den hohen Himalaya-Dörfern perfektioniert wurden.',
      readOurStory: 'Unsere Geschichte lesen',
    },
    // Benefits
    benefits: {
      freeShipping: 'Kostenloser Weltweiter Versand',
      freeShippingDesc: 'Bei Bestellungen über 150€',
      freeReturns: 'Kostenlose Rücksendung',
      freeReturnsDesc: '30 Tage problemlose Rückgabe',
      premiumQuality: 'Premium Qualität',
      premiumQualityDesc: '100% authentisches Kaschmir',
    },
    // Shop
    shop: {
      allCollections: 'Alle Kollektionen',
      shopAll: 'Alle Produkte',
      exploreCollection: 'Entdecken Sie unsere komplette Kollektion hochwertiger Kaschmir- und Wollkleidung.',
      filters: 'Filter',
      all: 'Alle',
      sortBy: 'Sortieren:',
      featured: 'Empfohlen',
      priceLowHigh: 'Preis: Niedrig bis Hoch',
      priceHighLow: 'Preis: Hoch bis Niedrig',
      nameAZ: 'Name: A-Z',
      showing: 'Zeige',
      products: 'Produkte',
      product: 'Produkt',
      noProducts: 'Keine Produkte in dieser Kategorie gefunden.',
      clear: 'Löschen',
    },
    // Product
    product: {
      backToShop: 'Zurück zum Shop',
      color: 'Farbe',
      size: 'Größe',
      addToCart: 'In den Warenkorb',
      fabricDetails: 'Stoffdetails',
      careInstructions: 'Pflegehinweise',
      youMayAlsoLike: 'Das könnte Ihnen auch gefallen',
      productNotFound: 'Produkt nicht gefunden',
    },
    // Cart
    cart: {
      title: 'Warenkorb',
      empty: 'Ihr Warenkorb ist leer',
      emptyDesc: 'Entdecken Sie unsere Kollektion hochwertiger Kaschmir- und Wollkleidung.',
      continueShopping: 'Weiter einkaufen',
      orderSummary: 'Bestellübersicht',
      subtotal: 'Zwischensumme',
      shipping: 'Versand',
      free: 'Kostenlos',
      addMore: 'Noch {amount}€ für kostenlosen Versand',
      total: 'Gesamt',
      includingTaxes: 'Inkl. Steuern',
      proceedToCheckout: 'Zur Kasse',
      secureCheckout: 'Sichere Zahlung über Stripe',
      qty: 'Anz.',
    },
    // Checkout
    checkout: {
      title: 'Kasse',
      contactInfo: 'Kontaktinformationen',
      email: 'E-Mail',
      phone: 'Telefon (optional)',
      shippingAddress: 'Lieferadresse',
      firstName: 'Vorname',
      lastName: 'Nachname',
      address: 'Adresse',
      city: 'Stadt',
      postalCode: 'Postleitzahl',
      country: 'Land',
      qualifyFreeShipping: 'Sie qualifizieren sich für kostenlosen weltweiten Versand!',
      paymentSecured: 'Ihre Zahlung wird durch Stripe gesichert',
      payNow: 'Jetzt bezahlen',
      processing: 'Wird verarbeitet...',
    },
    // Checkout Success
    success: {
      processing: 'Ihre Bestellung wird bearbeitet',
      pleaseWait: 'Bitte warten Sie, während wir Ihre Zahlung bestätigen...',
      thankYou: 'Vielen Dank für Ihre Bestellung!',
      paymentSuccess: 'Ihre Zahlung war erfolgreich. Wir haben Ihnen eine Bestätigungs-E-Mail mit Ihren Bestelldetails gesendet.',
      whatsNext: 'Was passiert als nächstes?',
      preparing: 'Wir bereiten Ihre Bestellung für den Versand vor',
      trackingInfo: 'Sie erhalten Tracking-Informationen per E-Mail',
      estimatedDelivery: 'Voraussichtliche Lieferung: 5-10 Werktage weltweit',
      amountPaid: 'Bezahlter Betrag',
      sessionExpired: 'Sitzung abgelaufen',
      sessionExpiredDesc: 'Ihre Zahlungssitzung ist abgelaufen. Bitte versuchen Sie es erneut.',
      somethingWrong: 'Etwas ist schief gelaufen',
      somethingWrongDesc: 'Wir konnten Ihre Zahlung nicht verarbeiten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
      returnToCart: 'Zurück zum Warenkorb',
      contactSupport: 'Support kontaktieren',
    },
    // About
    about: {
      ourStory: 'Unsere Geschichte',
      spiritOf: 'Der Geist von',
      ourPhilosophy: 'Unsere Philosophie',
      whereHeritageMeets: 'Wo Erbe auf Eleganz trifft',
      philosophyP1: 'Shiva Shakti repräsentiert das heilige Gleichgewicht gegensätzlicher Kräfte – Stärke und Anmut, Tradition und Innovation, Erde und Geist. Unsere Marke verkörpert diese Philosophie in jedem Faden.',
      philosophyQuote: '"Wir glauben, dass wahrer Luxus nicht im Überfluss liegt, sondern in der Reinheit der Materialien, dem Können menschlicher Hände und den Geschichten, die in jedes Kleidungsstück eingewebt sind."',
      philosophyP2: 'Mit der Vision gegründet, Himalaya-Handwerkskunst in die moderne Welt zu bringen, arbeiten wir mit Handwerkergemeinschaften zusammen, die ihr Handwerk über Jahrhunderte perfektioniert haben. Jedes Stück trägt die Wärme menschlicher Berührung und die Weisheit alter Traditionen.',
      whatWeStandFor: 'Wofür wir stehen',
      ourValues: 'Unsere Werte',
      authenticCraftsmanship: 'Authentische Handwerkskunst',
      authenticCraftsmanshipDesc: 'Jedes Stück wird von erfahrenen Kunsthandwerkern mit Techniken gefertigt, die über Generationen weitergegeben wurden. Wir bewahren die alte Kunst des Himalaya-Webens.',
      premiumMaterials: 'Premium Materialien',
      premiumMaterialsDesc: 'Wir verwenden nur das feinste Kaschmir der Güteklasse A und reine Wolle aus den Hochgebirgsregionen des Himalaya, um außergewöhnliche Weichheit und Haltbarkeit zu gewährleisten.',
      sustainablePractices: 'Nachhaltige Praktiken',
      sustainablePracticesDesc: 'Unser Engagement für Nachhaltigkeit bedeutet ethische Beschaffung, faire Löhne für Kunsthandwerker und umweltbewusste Produktionsmethoden.',
      timelessDesign: 'Zeitloses Design',
      timelessDesignDesc: 'Wir schaffen Stücke, die Trends überdauern – elegante, vielseitige Kleidungsstücke, die für Jahre geschätzt werden.',
      theProcess: 'Der Prozess',
      fromMountainToWardrobe: 'Vom Berg in den Kleiderschrank',
      processP1: 'Unser Kaschmir stammt von Changthangi-Ziegen, die frei auf den Hochebenen des Himalaya leben, wo extreme Temperaturen die feinsten, weichsten Fasern der Welt produzieren.',
      processP2: 'Jeden Frühling werden die Fasern sanft von Hand gekämmt – nie geschoren – um den Komfort der Tiere und die Qualität des Materials zu gewährleisten. Das rohe Kaschmir wird dann gereinigt, gesponnen und von Meisterhandwerkern mit traditionellen Webstühlen gewebt.',
      processP3: 'Das Ergebnis ist ein Kleidungsstück von außergewöhnlicher Qualität – leicht und dennoch unglaublich warm, weich auf der Haut und für Generationen gebaut.',
      weaverBlessing: '"In jeden Faden weben wir ein Gebet. Mit jeder Naht ehren wir unsere Vorfahren. Dies ist nicht nur Kleidung – es ist ein Vermächtnis der Liebe."',
      himalayanBlessing: '— Segen der Himalaya-Weber',
    },
    // Contact
    contact: {
      getInTouch: 'Kontaktieren Sie uns',
      title: 'Kontakt',
      description: 'Wir freuen uns, von Ihnen zu hören. Ob Sie eine Frage zu unseren Produkten, dem Versand oder etwas anderem haben – unser Team hilft Ihnen gerne.',
      sendMessage: 'Nachricht senden',
      name: 'Name',
      email: 'E-Mail',
      subject: 'Betreff',
      subjectPlaceholder: 'z.B. Bestellanfrage, Produktfrage',
      message: 'Nachricht',
      messagePlaceholder: 'Wie können wir Ihnen helfen?',
      send: 'Nachricht senden',
      sending: 'Wird gesendet...',
      contactInfo: 'Kontaktinformationen',
      phone: 'Telefon',
      hours: 'Öffnungszeiten',
      hoursValue: 'Mo-Fr: 9-18 Uhr MEZ',
      shippingPolicy: 'Versandrichtlinie',
      shippingP1: 'Kostenloser weltweiter Versand bei Bestellungen über 150€',
      shippingP2: 'Standardversandkosten variieren je nach Region',
      shippingP3: 'Expressversand an der Kasse verfügbar',
      shippingP4: 'Alle Bestellungen beinhalten Tracking-Informationen',
      returnsPolicy: 'Rückgabe & Erstattung',
      returnsP1: 'Kostenlose Rücksendung innerhalb von 30 Tagen nach Lieferung',
      returnsP2: 'Artikel müssen ungetragen mit Original-Etiketten sein',
      returnsP3: 'Vollständige Erstattung auf die ursprüngliche Zahlungsmethode',
      returnsP4: 'Kontaktieren Sie uns, um eine Rücksendung zu veranlassen',
      messageSent: 'Nachricht erfolgreich gesendet!',
      messageDesc: 'Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.',
    },
    // Footer
    footer: {
      tagline: '"Wo Himalaya-Erbe auf zeitgenössische Eleganz trifft."',
      shop: 'Shop',
      support: 'Support',
      aboutUs: 'Über uns',
      shippingPolicy: 'Versandrichtlinie',
      returnsRefunds: 'Rückgabe & Erstattung',
      securePayment: 'Sichere Zahlung',
      sslEncryption: 'Alle Transaktionen sind mit SSL-Verschlüsselung gesichert.',
      allRightsReserved: 'Alle Rechte vorbehalten.',
      privacyPolicy: 'Datenschutzrichtlinie',
      termsOfService: 'Nutzungsbedingungen',
    },
    // Admin
    admin: {
      login: 'Admin-Zugang',
      loginDesc: 'Bitte melden Sie sich an, um Produkte zu verwalten',
      username: 'Benutzername',
      password: 'Passwort',
      signIn: 'Anmelden',
      signingIn: 'Anmeldung...',
      productManagement: 'Produktverwaltung',
      productManagementDesc: 'Produkte hinzufügen, bearbeiten oder aus Ihrem Katalog entfernen',
      logout: 'Abmelden',
      addProduct: 'Produkt hinzufügen',
      noProducts: 'Keine Produkte gefunden',
      addFirstProduct: 'Erstes Produkt hinzufügen',
      image: 'Bild',
      name: 'Name',
      category: 'Kategorie',
      price: 'Preis',
      stock: 'Bestand',
      inStock: 'Auf Lager',
      outOfStock: 'Ausverkauft',
      featuredLabel: 'Empfohlen',
      standard: 'Standard',
      actions: 'Aktionen',
      editProduct: 'Produkt bearbeiten',
      addNewProduct: 'Neues Produkt hinzufügen',
      productName: 'Produktname',
      description: 'Beschreibung',
      productImages: 'Produktbilder',
      uploadFromDevice: 'Vom Gerät hochladen',
      addAnotherImage: 'Weiteres Bild hinzufügen',
      mapColorsToImages: 'Farben zu Bildern zuordnen',
      mapColorsDesc: 'Wählen Sie, welches Bild angezeigt werden soll, wenn ein Kunde eine Farbe auswählt.',
      selectImage: 'Bild für diese Farbe auswählen',
      noSpecificImage: 'Kein bestimmtes Bild',
      colors: 'Farben (kommagetrennt)',
      sizes: 'Größen (kommagetrennt)',
      fabricDetails: 'Stoffdetails',
      careInstructions: 'Pflegehinweise',
      featuredProduct: 'Empfohlenes Produkt',
      cancel: 'Abbrechen',
      updateProduct: 'Produkt aktualisieren',
      createProduct: 'Produkt erstellen',
      shippingConfig: 'Versandkonfiguration',
      shippingConfigDesc: 'Versandkosten nach Region konfigurieren',
      freeShippingThreshold: 'Schwelle für kostenlosen Versand (€)',
      germany: 'Deutschland',
      uk: 'Vereinigtes Königreich',
      eu: 'EU (außerhalb Deutschlands)',
      us: 'Vereinigte Staaten',
      restOfWorld: 'Rest der Welt',
      saveChanges: 'Änderungen speichern',
      saving: 'Speichern...',
    },
    // Language
    language: {
      en: 'English',
      de: 'Deutsch',
    },
    // Categories
    categories: {
      'cashmere-capes-ponchos': 'Kaschmir-Capes & Ponchos',
      'cashmere-pullovers': 'Reine Kaschmir-Pullover',
      'cashmere-caps': 'Kaschmir-Mützen',
      'tribal-ponchos': 'Woll-Tribal-Ponchos',
      'tribal-shorts': 'Tribal / Yoga-Hosen',
    },
  },
};

export default translations;
